var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.78 3.22c-4.3-4.3-11.26-4.3-15.56 0s-4.3 11.26 0 15.56 11.26 4.3 15.56 0 4.29-11.26 0-15.56zM4.77 18.45A6.296 6.296 0 0111 12.91a6.28 6.28 0 016.23 5.54 9.7 9.7 0 01-12.46 0zM11 11.58c-1.85 0-3.34-1.5-3.34-3.34S9.15 4.89 11 4.89s3.34 1.5 3.34 3.34c0 1.86-1.49 3.35-3.34 3.35zm7.34 5.78a7.594 7.594 0 00-4.74-5.29 4.633 4.633 0 00-5.18-7.68 4.633 4.633 0 000 7.68 7.573 7.573 0 00-4.75 5.28C.15 13.3.59 7.17 4.64 3.66s10.18-3.07 13.69.98a9.707 9.707 0 01.01 12.72z",
    fill: "#98a2bb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptAvatar);
export default __webpack_public_path__ + "static/media/recrypt_avatar.dc5add61.svg";
export { ForwardRef as ReactComponent };